<div class="w-100 h-100 map" *ngIf="apiLoaded">
<!--    <input #mapSearchField class="map-search">-->
    <img class="location_icon" src="assets/images/icons/global/location.png">
    <google-map #map
                [options]="mapConfiguration"
                [height]="'100%'"
                [width]="'100%'"
    ></google-map>
</div>
